// extracted by mini-css-extract-plugin
module.exports = {"input":"_2lA8NseVMRTQn9LdLFTvOC"};